export const progressSpinnerTheme = {
  extend: {
    colorScheme: {
      light: {
        color: {
          1: '{sd.backgrounds.secondary.color}',
          2: '{sd.backgrounds.secondary.color}',
          3: '{sd.backgrounds.secondary.color}',
          4: '{sd.backgrounds.secondary.color}'
        }
      }
    }
  }
};
